module.exports = __webpack_public_path__ + "img/pcBanner11.12169002.png";